import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c48d24c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Niveau "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-10" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Filière ", -1))
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-10" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Matière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "form-group mb-10" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Contenu "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_17 = { class: "border border-primary mb-10" }
const _hoisted_18 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white" }, "Ajouter les propositions")
], -1))
const _hoisted_20 = { class: "col-md-5" }
const _hoisted_21 = { class: "d-flex float-end" }
const _hoisted_22 = { class: "marge-droite" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
      /*#__PURE__*/_createTextVNode(" Contenu "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 text-center" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Correcte")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 text-center" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Action")
  ])
], -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-8" }
const _hoisted_26 = { class: "form-group mb-10" }
const _hoisted_27 = { class: "col-md-2 d-flex justify-content-center align-items-start pt-2" }
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "col-md-2 d-flex justify-content-center align-items-start pt-1" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16",
  class: "text-white"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
  })
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0" }, null, -1))
const _hoisted_34 = { class: "col-md-12 mt-5" }
const _hoisted_35 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "questionForm",
        onSubmit: _ctx.addQuestion,
        "validation-schema": _ctx.questionSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, { name: "niveau" }, {
                  default: _withCtx(({ field, handleChange }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.niveauOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: handleChange,
                      onSelect: _ctx.onNiveauChange,
                      placeholder: "Sélectionner un niveau"
                    }), null, 16, ["options", "onChange", "onSelect"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "niveau",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, { name: "filiere" }, {
                  default: _withCtx(({ field, handleChange }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.filiereOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: handleChange,
                      onSelect: _ctx.onFiliereChange,
                      placeholder: "Sélectionner une filière (facultatif)",
                      disabled: !_ctx.selectedNiveau || _ctx.isLoadingFilieres
                    }), null, 16, ["options", "onChange", "onSelect", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "filiere",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, { name: "matiere" }, {
                  default: _withCtx(({ field, handleChange }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.matiereOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: handleChange,
                      placeholder: "Sélectionner une matière",
                      disabled: !_ctx.selectedNiveau || _ctx.isLoadingMatieres
                    }), null, 16, ["options", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "matiere",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Field, {
                  name: "contenu",
                  type: "text",
                  class: "form-control shadow-none text-black",
                  placeholder: "Entrer le contenu",
                  modelValue: _ctx.formData.contenu,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.contenu) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "contenu",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "btn btn-success",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addProposition && _ctx.addProposition(...args)))
                  }, " Ajouter une proposition ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propositions, (proposition, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_Field, {
                          name: `propositions[${index}].contenu`,
                          type: "text",
                          class: _normalizeClass([
                        _ctx.validateField(proposition.contenu)
                          ? 'form-control shadow-none text-black is-invalid'
                          : 'form-control shadow-none text-black',
                      ]),
                          placeholder: "Entrer le contenu de la proposition",
                          modelValue: proposition.contenu,
                          "onUpdate:modelValue": ($event: any) => ((proposition.contenu) = $event)
                        }, null, 8, ["name", "class", "modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: `propositions[${index}].contenu`,
                          class: "text-danger"
                        }, null, 8, ["name"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        "onUpdate:modelValue": ($event: any) => ((proposition.estLaBonneReponse) = $event),
                        "true-value": true,
                        "false-value": false
                      }, null, 8, _hoisted_28), [
                        [_vModelCheckbox, proposition.estLaBonneReponse]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      (_ctx.propositions.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                            type: "button",
                            onClick: ($event: any) => (_ctx.removeProposition(index))
                          }, _hoisted_32, 8, _hoisted_30))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _hoisted_33
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-success me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                type: "submit"
              }, " Ajouter une question ", 2),
              _createVNode(_component_router_link, {
                to: "/liste-questions",
                class: "btn btn-danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Annuler ")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}